import React from 'react';
import CSSModules from 'react-css-modules';
import FacebookShare from 'src/components/FacebookShare/FacebookShare';
import styles from './RichUpdatesItemShareAlert.scss';

interface Props {
  updateId: number;
}

const RichUpdatesItemShareAlert: React.StatelessComponent<Props> = ({
  updateId,
}) => (
  <div className={styles.container}>
    <p className="jg-text--regular">Spread the word even further</p>
    <p className="jg-space-mbmd">The more you share the more you raise!</p>
    <div className={styles['facebook-container']}>
      <FacebookShare
        customStyle="jg-btn jg-btn--facebook"
        isActive
        isUpdate
        location="updates"
        buttonText="Share on Facebook"
        updateId={updateId}
      />
    </div>
  </div>
);

export default CSSModules(RichUpdatesItemShareAlert, styles);



// WEBPACK FOOTER //
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShareAlert/RichUpdatesItemShareAlert.tsx